<template>
  <div class="bg-white rounded-lg p-2">
    <div class="flex justify-center">
      <LoadingSpinner
        class="h-10 w-10 text-yellow-500/80 my-8"
        v-if="loading"
      />
      <apexchart
        class=""
        type="bar"
        width="350"
        :options="options"
        :series="series"
        v-else-if="this.series[0].data.length"
      />
      <h6 class="my-8 text-gray-600" v-else>بدون داده</h6>
    </div>
  </div>
</template>
<script>
import { horekaSaleReport } from "../API/API";
import LoadingSpinner from "./General/LoadingSpinner.vue";

export default {
  name: "SaleMabChart",
  components: { LoadingSpinner },
  props: ["year", "month", "day"],
  data() {
    return {
      loading: true,
      series: [],
      options: {
        chart: {
          height: 350,
          type: "area",
        },
        colors: ["#14532D"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  created() {
    this.getReports();
  },
  methods: {
    getReports() {
      this.series = [];
      //this.options.labels = [];
      this.loading = true;
      horekaSaleReport("day", "mab", this.year, this.month, this.day).then(
        (resp) => {
          this.options = { ...this.options, xaxis: { categories: resp.data.result.xaxis, },};
          resp.data.result.yaxis.forEach((item) => {
            this.series.push({
              name: item.name,
              data: item.dData,
            });
          });
          this.loading = false;
        }
      );
    },
  },
  watch: {
    day() {
      if (this.day !== "") this.getReports();
    },
    month() {
      this.getReports();
    },
    year() {
      this.getReports();
    },
  },
};
</script>
